export const GALLERY_IMAGES = [
  "617927470_122113432779144857_536450615729982147_n.jpg",
  "618068664_122113432995144857_8527307743144685889_n.jpg",
  "618227524_122113431843144857_2861552991813200535_n.jpg",
  "618231616_122113431489144857_2120703518696915316_n.jpg",
  "618250034_122113432803144857_5097551973335532993_n.jpg",
  "618402834_122113432617144857_1801327365313558121_n.jpg",
  "618513074_122113432929144857_3591328550216988334_n.jpg",
  "619279887_122113417365144857_1470799807292212034_n.jpg",
  "619311533_122113432125144857_4805965226445702915_n.jpg",
  "619319404_122113432611144857_2983042152419134770_n.jpg",
  "619403833_122113432185144857_6607271212469702910_n.jpg",
  "619493924_122113431981144857_6981825635600726238_n.jpg",
  "619623352_122113432281144857_7712461909133146014_n.jpg",
  "645623785_122120076429144857_8133783830570556185_n.jpg",
  "647139994_122120076411144857_5842501599012403720_n.jpg",
  "713703370_122131779861144857_3524340918285714889_n.jpg",
  "714830907_122132146947144857_1446495783713270929_n.jpg",
  "715910362_122131780797144857_6858140426890726917_n-2.jpg",
  "718870126_122131780785144857_5701772471245526438_n.jpg",
  "719918571_122131780737144857_5404581399563321201_n.jpg",
  "720563325_122132147001144857_8180146208006322030_n.jpg",
  "729293601_122133383397144857_5593131952491356463_n.jpg",
  "last_741757267_122134834953144857_2659727981829904713_n.jpg",
].map((file, index) => ({
  id: file,
  src: `/images/${file}`,
  featured: index === 0 || index === 7 || index === 16,
}));
